import { IDiscordAttachment } from "#api/discord";
import { ImageViewer } from "#components/image-viewer";

import * as styles from "./styles.module.scss";

const imageTypes = [
  "apng",
  // "avif", // Not well-supported
  "gif",
  "jpg",
  "png",
  "webp",
];

const videoTypes = [
  "webm",
  "mp4",
]

interface IAttachmentProps {
  path: string;
  name: string;
}

// function Text({ path, name }: IAttachmentProps) {
//   return (

//   )
// }

const archives = ["7z", "rar", "zip", "tar"]

function Download({ path, name }: IAttachmentProps) {
  let ext = path.split(".")[1];

  return (
    <div className={styles.downloadAttachment}>
      <img src={archives.includes(ext) ? "/static/discord/archive.svg" : "/static/discord/file.svg"} />
      <div>
        <a href={path}>{name}</a>
        <span>
          {/* TODO: filesize */}
        </span>
      </div>
    </div>
  );
}

function Video({ path, name }: IAttachmentProps) {
  return (
    <div>
      <span className={styles.attachmentLink}>
        <a href={`/data${path}?f=${encodeURIComponent(name)}`}>
          <svg id="attachment" aria-hidden="true" role="img" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="M10.57 4.01a6.97 6.97 0 0 1 9.86 0l.54.55a6.99 6.99 0 0 1 0 9.88l-7.26 7.27a1 1 0 0 1-1.42-1.42l7.27-7.26a4.99 4.99 0 0 0 0-7.06L19 5.43a4.97 4.97 0 0 0-7.02 0l-8.02 8.02a3.24 3.24 0 1 0 4.58 4.58l6.24-6.24a1.12 1.12 0 0 0-1.58-1.58l-3.5 3.5a1 1 0 0 1-1.42-1.42l3.5-3.5a3.12 3.12 0 1 1 4.42 4.42l-6.24 6.24a5.24 5.24 0 0 1-7.42-7.42l8.02-8.02Z" class=""></path>
          </svg>
          {name}
        </a>
      </span>
      <video src={`/data${path}?f=${encodeURIComponent(name)}`} controls />
    </div>
  );
}

interface IProps {
  attachments: IDiscordAttachment[];
}

export function Attachments({ attachments }: IProps) {
  if (!attachments.length) {
    return;
  }

  let { images, videos, downloads } = Object.groupBy(attachments, (item) => {
    let ext = item.path.split(".")[1];
    if (imageTypes.includes(ext)) return "images";
    else if (videoTypes.includes(ext)) return "videos";
    else return "downloads";
  });

  return (
    <div className={styles.attachmentContainer}>
      {images?.length ? (
        <ImageViewer images={images} />
      ) : undefined}
      {videos?.length ? (
        <>
          {videos.map(video => <Video path={video.path} name={video.name} />)}
        </>
      ) : undefined}
      {downloads?.length ? (
        <>
          {downloads.map(download => <Download name={download.name} path={download.path} />)}
        </>
      ) : undefined}
    </div>
  )
}
